import React, { useEffect } from 'react'
import Header from '../../../headerone/Main'
import Bredcom from '../../../Bredcom/Main'
import SeniorHousingAssistanceDetails from '../../subdepartmentdetails/SeniorHousingAssistance'


function SeniorHousingAssistance() {

  useEffect(() => {
    document.getElementById("title").innerHTML="Senior Housing and Independent Living Assistance || Senior Services";
  }, [])


  return (
    <>
        {/* Header is now rendered at app level in routes/index.js to prevent remounting on navigation */}

        <div className="page-wrapper">
        <Bredcom 
            subtitle="Senior Services"
            title="Senior Housing Assistance"
            subtitledown="Department of Senior Services"
           />
            <SeniorHousingAssistanceDetails/>
        </div>
    </>
  )
}

export default SeniorHousingAssistance